module.exports = __webpack_public_path__ + "img/trip-bar.56729d70.svg";